export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export function stripTags(input){
  if (!input) return '';
  return input.replace(/<\/?[^>]+(>|$)/g, '');
}